import { Form } from 'antd'
import { useEffect } from 'react'

const useInitializeProfileAdvancedForm = (initialData) => {
  /* Getting form instance */
  const [form] = Form.useForm()
  /* Setting initial data */
  useEffect(() => {
    if (initialData) {
      /* Getting initial values */
      const { user } = initialData

      /* Formatting date fields */
      const formValues = {
        user: {
          firstName: user?.['firstName'] ?? null,
          lastName: user?.['lastName'] ?? null,
          phoneNumber: user?.['phoneNumber'],
          email: user?.['email'] ?? null,
          avatarUrl: user?.['avatarUrl'] ?? null
        }
      }

      /* Setting initial values to form instance */
      form.setFieldsValue(formValues)
    }
  }, [initialData, form])

  return { form }
}

export default useInitializeProfileAdvancedForm
